export const CONFIRMED_BOOKING_STATES = ['accepted', 'crew_assigned', 'in_progress', 'awaiting_client_confirmation', 'completed'];

export function closedRequest(bookingState, jobStatus) {
  if (bookingState === 'declined') return { title: 'Job declined', message: 'This job request was declined. No further action is needed on this request.' };
  if (['cancelled', 'cancelled_by_client'].includes(bookingState) || jobStatus === 'cancelled') {
    return { title: 'Job cancelled', message: 'This job has been cancelled. You can review the request details below.' };
  }
  return null;
}
